export default "__VITE_PUBLIC_ASSET__684b1e73__"